import { useState, useEffect, useRef } from 'react'
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from '@material-ui/core'
import ReactHtmlParser from 'react-html-parser';
import Swal from 'sweetalert2'
import Header from '../componentes/Header'
import Footer from '../componentes/Footer'
import moment from 'moment'
import firebase from 'firebase'
import './Filiacao.css'

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { atualizaPagamentoMP, consultaPagamentosMP } from '../service/MercadoPago';


export default function Carteirinha() {


  const queryParams = new URLSearchParams(window.location.search);
  const idFederacao = queryParams.get('fd')
  const idFiliacao = queryParams.get('fl')
  const tipoCarteirinha = queryParams.get('tp') ? queryParams.get('tp') : 'fis';

  const [servicos] = useState({
    eventos: firebase.firestore().collection("eventos"),
    equipes: firebase.firestore().collection("equipes"),
    usuarios: firebase.firestore().collection("usuarios"),
    inscricoes: firebase.firestore().collection('inscricoes'),
    federacoes: firebase.firestore().collection('federacoes'),
    filiacoes: firebase.firestore().collection('federacoes').doc(idFederacao).collection('filiacoes'),
    mail: firebase.firestore().collection('mail'),
    configuracoes: firebase.firestore().collection('configuracoes'),
    auth: firebase.auth()
  })

  const [federacao, setFederacao] = useState({})
  const [filiacao, setFiliacao] = useState({});
  const [carteirinhas, setCarteirinhas] = useState([])
  let [carteirinhaPendente, setCarteirinhaPendente] = useState(null);


  const [usuario, setUsuario] = useState({})
  const [novaCarteirinha, setNovaCarteirinha] = useState(false);
  const [opcaoEntregaSelecionado, setOpcaoEntregaSelecionado] = useState('')

  // Endereço de Entrega da Carteirinha

  const [endereco, setEndereco] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [uf, setUf] = useState('');
  const [cep, setCep] = useState('');


  const UFs = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MS', 'MT', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
  ]


  const mediaQuery = window.matchMedia('(max-width: 650px)');



  useEffect(() => {

    carregarUsuario();
    carregarCarteirinhas();
    carregarFederacao()

  }, [])

  function carregarUsuario() {
    servicos.auth.onAuthStateChanged(async (user) => {
      let idUser = JSON.parse(localStorage.getItem('usuarioId'))

      if (user || idUser) {

        servicos.usuarios.doc(user.uid ? user.uid : idUser).get().then(async (doc) => {
          if (doc.exists) {
            setUsuario(doc.data())

            servicos.filiacoes.doc(idFiliacao).get().then(snap => {

              if(!snap.exists){
                 window.location = '/';
                 return;
              }

              const _filiacao = snap.data();

                if (tipoCarteirinha === 'dig') {
                  if (_filiacao?.habilitarCarteirinhaDigital === '1') {
                    window.location = `/detalheFiliacao?f=${idFederacao}&fl=${idFiliacao}`;
                    return;
                  }
                }

                if(_filiacao?.statusFiliacao !== 2){
                  window.location = `/detalheFiliacao?f=${idFederacao}&fl=${idFiliacao}`;
                  return;
                }

                setFiliacao(_filiacao);

            })

          }

        })

      } else {
         window.location = '/';
         return;
      }

    })
  }

  function carregarCarteirinhas() {

    const tipo = tipoCarteirinha === 'dig' ? 'digital' : 'fisica';

    servicos.filiacoes.doc(idFiliacao).collection('carteirinhas')
      .where('tipoCarteirinha', '==', tipo)
      .get().then(snap => {

        if (!snap.empty) {

          const _carteirinhas = snap.docs.map(d => d.data())
          setCarteirinhas(_carteirinhas);
          atualizarPagamentoCarteirinhas(_carteirinhas);

        }
      })
  }

  function carregarFederacao() {
    servicos.federacoes.doc(idFederacao).get().then(snap => {

      if(!snap.exists) {
          window.location = '/';
          return;
      }

      const _federacao = snap.data()
      const opcional = '2';
      setFederacao(_federacao);

      if (tipoCarteirinha === 'dig') {
        if (_federacao?.carteirinha?.carteirinhaDigital !== opcional) {
          window.location = '/';
          return;
        }
      }

    })
  }

  async function atualizarPagamentoCarteirinhas(_carteirinhas) {

    const existeCarteirinhaPendente = _carteirinhas.some(crt => crt.status !== 5);

    if (existeCarteirinhaPendente) {

      const _carteirinhaPendente = _carteirinhas.find(crt => crt.status !== 5);
      setCarteirinhaPendente(_carteirinhaPendente);

    }

    let pagamentosOnlinePendentes = _carteirinhas.filter(carteirinha => {
      if (carteirinha?.pagamento?.tipoPagamento === 'online') {
        if (carteirinha?.pagamento?.status !== 2) {
          return true;
        }
      }
      return false;
    })

    if (pagamentosOnlinePendentes.length > 0) {
      
      const carteirinhaPendente = pagamentosOnlinePendentes[0];
      const external_reference = `crt-${idFederacao}-${idFiliacao}-${carteirinhaPendente.id}`;
      const chavePagamento =
        carteirinhaPendente?.pagamento?.dadosApi?.refChavePgto ?
          carteirinhaPendente?.pagamento?.dadosApi?.refChavePgto :
          carteirinhaPendente?.refChavePgto ?
            carteirinhaPendente?.refChavePgto :
            federacao.chavePagamento ?
              federacao.chavePagamento : null;

      console.log('pagamentosOnlinePendentes: ', pagamentosOnlinePendentes);
      

      // consultaPagamentosMP(external_reference, chavePagamento)

      for (let i = 1; i <= 3; i++) {

        // const response = await consultaPagamentosMP(external_reference, chavePagamento)
        const response = await atualizaPagamentoMP(external_reference, chavePagamento)

        if (!response) {
          continue;
        }

        if (response?.semPgto) {
          break
        }

        if (response.pgtoJaAprovado || response.pgtoAlterado) {
          window.location.reload();
        }

        await new Promise((resolve) => {
          setTimeout(() => {
            resolve()
          }, 15000)
        })


      }

    }

  }


  function mensagemAtencao(msg) {
    Swal.fire('Atenção', msg, 'warning')
  }

  function mensagemEndereco(carteinha) {

    let texto = '';
    const enviarAoFiliado = '2';
    const retiradaNaFederacao = '1';

    if (
      carteinha?.opcaoEntregaSelecionado == enviarAoFiliado ||
      federacao?.opcaoEntrega == enviarAoFiliado
    ) {

      if (carteinha?.opcaoEntregaSelecionado == enviarAoFiliado) {
        texto = 'Opção de entrega escolhido: <b>Enviar ao Filiado</b><br/>'
      }
      texto += `
      <b>Endereço:</b> ${carteinha?.enderecoEntregaCarteirinha?.endereco}
      <b>Numero:</b> ${carteinha?.enderecoEntregaCarteirinha?.numero}
      <b>Complemento:</b> ${carteinha?.enderecoEntregaCarteirinha?.complemento ? carteinha?.enderecoEntregaCarteirinha?.complemento : '--'}
      <b>Bairro:</b> ${carteinha?.enderecoEntregaCarteirinha?.bairro}
      <b>Cidade:</b> ${carteinha?.enderecoEntregaCarteirinha?.cidade}
      <b>UF:</b> ${carteinha?.enderecoEntregaCarteirinha?.uf}
      <b>CEP:</b> ${carteinha?.enderecoEntregaCarteirinha?.cep}
      `
    } else if (
      carteinha?.opcaoEntregaSelecionado == retiradaNaFederacao ||
      federacao?.opcaoEntrega == retiradaNaFederacao
    ) {
      if (carteinha?.opcaoEntregaSelecionado == retiradaNaFederacao) {
        texto = 'Opção de entrega escolhido: <b>Retirar na Federação</b><br/>'
      }
      texto += federacao?.carteirinha?.enderecoRetiradaCarteirinha
    }


    Swal.fire({
      title: 'Endereço / Local de Entrega da carteirinha',
      html: texto,
      icon: 'info',
      customClass: {
        content: 'swal-message'
      }
    })
  }

  function mensagemAlerta(msg) {
    Swal.fire('Alerta', msg, 'warning')
  }
  function mensagemReprovado(msg) {
    Swal.fire('Solicitação Reprovada', msg, 'warning')
  }

  function mensagemObservacao(status, msg) {

    switch (status) {
      case 1:
        Swal.fire('Solicitação Pendente', 'Aguarde. A solicitção da carteirinha será processada em breve. ', 'info'); break;
      case 2:
        Swal.fire('Em Produção', 'A carteirinha já está sendo confeccionada e ficará pronta em breve. ', 'info'); break;
      case 3:
        Swal.fire('Solicitação Reprovada', msg, 'warning'); break;
      case 4:
        Swal.fire('Retirada Disponível', 'A carteirinha já pode ser retirada no endereço da Federação. ', 'info'); break;
      case 5:
        Swal.fire('Concluído!', 'Carteirinha entregue.', 'success'); break;
    }
  }


  function mensagemObservacaoPendente(carteirinha) {

    let mensagem = '';
    let qtd = 0;
    let titulo = '';
    let icon = '';

    if (carteirinha?.pagamento?.status === 3 || carteirinha.status === 3) {
      if (carteirinha.status === 3) {
        qtd++;
        mensagem += `${qtd} - ${carteirinha.observacao} </br>`;
        titulo = 'Solicitação Reprovada';
        icon = 'warning';

      }

      if (carteirinha?.pagamento?.status === 3) {
        qtd++;
        titulo = 'Solicitação Reprovada';
        mensagem += `${qtd} - ${carteirinha?.pagamento?.observacao}`;
        icon = 'warning';

      }

    } else {

      switch (carteirinha?.status) {
        case 0:
          mensagem = `Sua solicitação está <b>pendente de pagamento</b>. Realize o pagamento para concluir sua solicitação de carteirinha.`;
          titulo = 'Solicitação Pendente de Pagamento';
          icon = 'warning';
          break;

        case 1:
          mensagem = `Aguarde! A solicitção da carteirinha será processada em breve.`;
          titulo = 'Agora é só aguardar!';
          icon = 'info';
          break;

        case 2:
          mensagem = `Aguarde. A carteirinha já está sendo confeccionada e ficará pronta em breve.`;
          titulo = 'Em Produção';
          icon = 'info';
          break;

        case 4:
          mensagem = `A carteirinha já pode ser retirada no endereço da Federação.`;
          titulo = 'Retirada Disponível';
          icon = 'info';
          break;

        case 5:
          mensagem = `Carteirinha entregue.`;
          titulo = 'Concluído!';
          icon = 'success';
          break;
      }

    }


    Swal.fire({
      title: titulo,
      html: mensagem,
      icon: icon,
    });

  }

  function mensagemSucesso(msg, idInscricao) {
    Swal.fire('Sucesso', msg, 'success').then(() => {
      window.location.reload();
      // if (itemVoucher.id && itemVoucher.tipo === 'cortesia') {
      //   window.location = window.location.href.replace('/inscricao/' + id, '/evento/' + evento.id)
      // } else if ((valorAbsoluto + valorCategoria) === 0) {
      //   window.location = window.location.href.replace('/inscricao/' + id, '/minhaInscricao/' + id)
      // } else {
      //   window.location.href = `/pagamento?e=${id}&i=${idInscricao}`
      // }

    })
  }

  function mensagemLoading(msg) {
    Swal.fire({
      title: 'Aguarde',
      html: msg,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })
  }

  async function mensagemConfirmacao(titulo, texto) {

    const result = await Swal.fire({
      title: titulo,
      text: texto,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    });
    if (result.isConfirmed) {
      return true;
    } else if (result.isDismissed || result.isDenied) {
      return false;
    }
  }

  function mensagemErro(msg) {
    Swal.fire('Erro', msg, 'error')
  }




  function converterData(data) {
    return moment(new firebase.firestore.Timestamp(data.seconds, data.nanoseconds).toDate()).format('DD-MM-YYYY HH:mm')
  }

  async function salvar() {

    if (!validacao()) {
      return;
    }

    const titulo = 'Confirmar solicitação';
    const texto = `Confirma solicitação para carteirinha${tipoCarteirinha === 'dig' ? ' digital' : ''}?`;

    if (! await mensagemConfirmacao(titulo, texto)) {
      return;
    }

    mensagemLoading('Aguarde. Gerando solicitação de carteirinha...');

    try {

      let dados = gerarDadosCarteirinha();

      const carteirinhaDocRef = await servicos.filiacoes.doc(idFiliacao).collection('carteirinhas').add(dados)

      await servicos.filiacoes.doc(idFiliacao).collection('carteirinhas').doc(carteirinhaDocRef.id).update({
        id: carteirinhaDocRef.id
      })

      if (valorTotal() > 0) {

        const mensagem = 'Você agora será redirencionado para a etapa de pagamento da sua carteirinha. Escolha a forma de pagamento de sua preferência.'
        Swal.fire('Sucesso', mensagem, 'info').then(() => {
          window.location.href = `/carteirinha/pagamento?fd=${idFederacao}&fl=${idFiliacao}&tp=${tipoCarteirinha}&crt=${carteirinhaDocRef.id}`;
        })


      } else {
        mensagemSucesso('Solicitação gerada com sucesso.');
      }

    } catch (error) {
      // mensagemErro('Erro ao gerar solicitação de carteirinha.')
      console.log('Erro ao gerar solicitação de carteirinha: ', error);
    }

  }

  async function alterarDados(carteirinha) {

    if (!validarAlteracao()) {
      return;
    }

    let texto = 'Confirma alteração de dados?'

    if (! await mensagemConfirmacao("Confirmar alteração", texto)) {
      return;
    }

    carteirinha.exibirDetalhes = false;
    carteirinha.observacao = '';
    const idCarteirinha = carteirinha.id;

    if (carteirinha.status === 3) {
      carteirinha.status = 1;
    }

    await servicos.federacoes.doc(idFederacao).collection('filiacoes').doc(idFiliacao).collection('carteirinhas').doc(idCarteirinha).update(carteirinha);

    texto = '';

    if (carteirinha?.origemEmissao === 'individual') {
      if (carteirinha?.pagamento) {
        if (carteirinha?.pagamento?.status === 3) {

          texto = "Dados Alterados com sucesso. Você também possui uma pendência referente ao pagamento. Verifique sua pendencia para concluir sua solitiação.";

          Swal.fire({
            title: 'Dados Alterados!',
            html: texto,
            icon: 'info'
          }).then(() => {
            window.location.href = `/carteirinha/pagamento?fd=${idFederacao}&fl=${idFiliacao}&tp=${tipoCarteirinha}&crt=${carteirinha?.id}`
          })

          return;

        }

        if (!carteirinha?.pagamento?.status || carteirinha?.pagamento?.status === 0) {

          texto = "Dados Alterados com sucesso. Para concluir sua solicitação, realize o pagamento de sua carteirinha.";

          Swal.fire({
            title: 'Dados Alterados!',
            html: texto,
            icon: 'info'
          }).then(() => {
            window.location.href = `/carteirinha/pagamento?fd=${idFederacao}&fl=${idFiliacao}&tp=${tipoCarteirinha}&crt=${carteirinha?.id}`
          })

          return;


        }
      }
    }

    texto = "Dados Alterados com sucesso.";

    Swal.fire({
      title: 'Dados Alterados!',
      html: texto,
      icon: 'info'
    }).then(() => {
      window.location.reload();
    })


  }

  function gerarDadosCarteirinha() {


    let valorCarteirinha = federacao?.carteirinha?.valorCarteirinha ? parseFloat(federacao?.carteirinha?.valorCarteirinha) : 0;

    if (tipoCarteirinha === 'dig') {
      valorCarteirinha = federacao?.carteirinha?.valorCarteirinhaDigital ? parseFloat(federacao?.carteirinha?.valorCarteirinhaDigital) : 0;
    }

    let dados = {
      status: 0,
      valorCarteirinha: valorCarteirinha,
      valorTotal: valorTotal(),
      tipoCarteirinha: tipoCarteirinha === 'dig' ? 'digital' : 'fisica',
      dtPedido: firebase.firestore.Timestamp.fromDate(new Date()),
      idFiliacao: idFiliacao,
      idFederacao: idFederacao,
      idFiliado: filiacao.idFiliado,
      urlAvatarFiliado: filiacao.urlAvatarFiliado,
      nomeFiliado: filiacao.nomeFiliado,
      cpfFiliado: filiacao.cpfFiliado,
      origemEmissao: 'individual'

    }

    if (tipoCarteirinha !== 'dig') {
      if (cobrarTaxaEnvio()) {
        const valorTaxaEnvio = federacao?.carteirinha?.valorTaxaEnvio ? federacao?.carteirinha?.valorTaxaEnvio : 0;
        dados = {
          ...dados,
          cobrarTaxaEnvio: true,
          valorTaxaEnvio: valorTaxaEnvio
        }
      }

      if (federacao?.carteirinha?.opcaoEntrega == '3' && opcaoEntregaSelecionado) {
        dados = {
          ...dados,
          opcaoEntregaSelecionado: opcaoEntregaSelecionado
        }
      }

      const enviarAoFiliado = '2';

      if (
        opcaoEntregaSelecionado === enviarAoFiliado ||
        federacao?.carteirinha?.opcaoEntrega == enviarAoFiliado
      ) {
        dados = {
          ...dados,
          enderecoEntregaCarteirinha: {
            endereco: endereco,
            numero: numero,
            complemento: complemento,
            bairro: bairro,
            cidade: cidade,
            uf: uf,
            cep: cep
          }
        }
      }
    }



    if (valorTotal() === 0) {
      dados = {
        ...dados,
        status: 1,
        pagamento: {
          status: 2,
          tipoPagamento: 'sem custo',
          aprovadoPor: 'aprovação automática',
          aprovadoPorAdmin: false,
          dtAprovado: firebase.firestore.Timestamp.fromDate(new Date()),
          valorPago: 0,
        }
      }
    }

    return dados;

  }

  function validacao() {


    if (tipoCarteirinha === 'fis') {
      // Validar endereço de entrega da carteirinha
      const opcional = '3';
      const envioAoFiliado = '2';

      if (federacao?.carteirinha?.opcaoEntrega == opcional) {
        if (!opcaoEntregaSelecionado) {
          mensagemAlerta('Por favor, selecione uma opção para entrega da carteirinha');
          return false;
        }
      }

      if (
        federacao?.carteirinha?.opcaoEntrega == envioAoFiliado ||
        (federacao?.carteirinha?.opcaoEntrega == opcional && opcaoEntregaSelecionado == envioAoFiliado)) {

        if (!endereco) {
          mensagemAlerta('Por favor, informe o endereço para envio de carteirinha ao filiado.');
          return false;
        }
        if (!numero) {
          mensagemAlerta('Por favor, informe o número residencial para envio de carteirinha ao filiado.');
          return false;
        }

        if (!cidade) {
          mensagemAlerta('Por favor, informe a cidade para envio de carteirinha ao filiado.');
          return false;
        }

        if (!uf) {
          mensagemAlerta('Por favor, informe a uf para envio de carteirinha ao filiado.');
          return false;
        }
        if (!cep) {
          mensagemAlerta('Por favor, informe a cep para envio de carteirinha ao filiado.');
          return false;
        }

      }
    }



    if (carteirinhaPendente?.id) {
      mensagemAlerta('Você já possui um pedido de carteirinha em processamento. Não será possível gerar um novo pedido.')
      return false;
    }

    return true;

  }
  function validarAlteracao() {


    if (carteirinhaPendente?.tipoCarteirinha === 'fisica') {
      // Validar endereço de entrega da carteirinha
      const opcional = '3';
      const envioAoFiliado = '2';

      if (federacao?.carteirinha?.opcaoEntrega == opcional) {
        if (!carteirinhaPendente?.opcaoEntregaSelecionado) {
          mensagemAlerta('Por favor, selecione uma opção para entrega da carteirinha');
          return false;
        }
      }

      if (federacao?.carteirinha?.opcaoEntrega == envioAoFiliado || carteirinhaPendente?.opcaoEntregaSelecionado == envioAoFiliado) {

        if (!carteirinhaPendente?.enderecoEntregaCarteirinha?.endereco) {
          mensagemAlerta('Por favor, informe o endereço para envio de carteirinha ao filiado.');
          return false;
        }
        if (!carteirinhaPendente?.enderecoEntregaCarteirinha?.numero) {
          mensagemAlerta('Por favor, informe o número residencial para envio de carteirinha ao filiado.');
          return false;
        }

        if (!carteirinhaPendente?.enderecoEntregaCarteirinha?.cidade) {
          mensagemAlerta('Por favor, informe a cidade para envio de carteirinha ao filiado.');
          return false;
        }

        if (!carteirinhaPendente?.enderecoEntregaCarteirinha?.uf) {
          mensagemAlerta('Por favor, informe a uf para envio de carteirinha ao filiado.');
          return false;
        }
        if (!carteirinhaPendente?.enderecoEntregaCarteirinha?.cep) {
          mensagemAlerta('Por favor, informe a cep para envio de carteirinha ao filiado.');
          return false;
        }

      }
    }



    return true;

  }




  function exibirBotaoAlterarDados() {
    return (carteirinhaPendente?.status === 3) ? true : false;
  }




  function handleEditarEndereco(valor, campo) {
    const _carteirinhaPendente = { ...carteirinhaPendente }
    _carteirinhaPendente.enderecoEntregaCarteirinha[campo] = valor;
    setCarteirinhaPendente(_carteirinhaPendente)
  }

  function handleSelecaoOpcaoEntrega(valor) {
    const _carteirinhaPendente = { ...carteirinhaPendente }
    _carteirinhaPendente.opcaoEntrega = valor;
    setCarteirinhaPendente(_carteirinhaPendente)
  }

  function handleExibirDetalhesCarteirinhaPendente() {
    const crtPend = { ...carteirinhaPendente };
    crtPend.exibirDetalhes = !Boolean(crtPend?.exibirDetalhes);
    setCarteirinhaPendente(crtPend)
  }



  function exibirBotaoPagamento() {
    if (carteirinhaPendente?.id) {
      if (carteirinhaPendente?.origemEmissao === 'individual') {
        if (carteirinhaPendente?.pagamento?.status !== 2) {
          if (carteirinhaPendente?.valorTotal > 0) {
            return true;
          }
        }
      }
    }
    return false;
  }

  function exibirBotaoDetalhes() {
    if (carteirinhaPendente?.id) {
      if (true) {
        if (carteirinhaPendente?.pagamento?.status !== 2) {
          if (carteirinhaPendente?.valorTotal > 0) {
            return true;
          }
        }
      }
    }
    return false;
  }

  async function enviarEmail() {
    const destinatario = federacao?.email;
    const enviarNotificao = (destinatario && federacao?.receberNotificacaoEmail)

    if (enviarNotificao) {
      const emailNotificacao = {
        to: destinatario,
        from: 'Procompetidor',
        message: {
          subject: 'Nova solicitação de carteirinha',
          html: '<html>' +
            '<body>' +
            '<p>Atenção! Você possui uma nova solicitação de <b>carteirinha</b> para processar/aprovar. Verifique sua lista de carteirinhas. </p>' +
            '<p>solcitante: <b>' + `${filiacao?.nomeFiliado}` + ' </b></p>' +
            '<br/> <br/>' +
            '<h5>Equipe Procompetidor</h5>' +
            '</body>' +
            '</html>'
        }
      }

      servicos.mail.add(emailNotificacao)
      console.log('email enviado');

    }

  }

  function mensagemStatus(status) {
    let mensagem = ''
    switch (status) {
      case 0: mensagem = 'Rascunho'; break;
      case 1: mensagem = 'Pendente'; break;
      case 2: mensagem = 'Em Produção'; break;
      case 3: mensagem = 'Reprovada'; break;
      case 4: mensagem = 'Retirada Disponível'; break;
      case 5: mensagem = tipoCarteirinha === 'dig' ? 'Habilitada' : 'Entregue'; break;
      default: mensagem = ''; break;
    }

    return mensagem;
  }

  function corMensagem(carteirinha) {

    let cor = '';

    if (carteirinha) {
      if (carteirinha?.pagamento?.status === 3 || carteirinha.status === 3) {
        cor = 'red';
      } else {

        switch (carteirinha?.status) {
          case 0: cor = 'orange'; break;
          case 1: cor = '#2778c4'; break;
          case 2: cor = '#2778c4'; break;
          case 4: cor = '#2778c4'; break;
          case 5: cor = 'green'; break;
        }

      }
    }



    return cor;


  }


  function valorTotal() {

    let valor = 0;

    if (tipoCarteirinha === 'dig') {

      if (federacao?.carteirinha?.tipoAquisicaoCarteirinhaDigital == '1') {
        valor += federacao?.carteirinha?.valorCarteirinhaDigital ? parseFloat(federacao?.carteirinha?.valorCarteirinhaDigital) : 0;
      }

    } else {

      valor += federacao?.carteirinha?.valorCarteirinha ? parseFloat(federacao?.carteirinha?.valorCarteirinha) : 0;

      if (cobrarTaxaEnvio()) {
        if (federacao?.carteirinha?.valorTaxaEnvio) {
          valor += parseFloat(federacao?.carteirinha?.valorTaxaEnvio);
        }
      }

    }


    return valor;

  }

  function valorCarteirinha() {
    let valor = 0;

    if (tipoCarteirinha === 'dig') {

      if (federacao?.carteirinha?.tipoAquisicaoCarteirinhaDigital == '1') {
        valor += federacao?.carteirinha?.valorCarteirinhaDigital ? parseFloat(federacao?.carteirinha?.valorCarteirinhaDigital) : 0;
      }

    } else {

      valor += federacao?.carteirinha?.valorCarteirinha ? parseFloat(federacao?.carteirinha?.valorCarteirinha) : 0;
    }

    return valor;

  }

  function cobrarTaxaEnvio() {

    // todo: incluir mecanismo para inclusão de carteirinha opcional
    const enviarAoFiliado = '2';
    const opcional = '3';
    const sim = '1';

    return (
      (
        federacao?.carteirinha?.opcaoEntrega == enviarAoFiliado ||
        (federacao?.carteirinha?.opcaoEntrega == opcional && opcaoEntregaSelecionado == enviarAoFiliado)
      ) &&
      federacao?.carteirinha?.cobrarTaxaEnvio === sim
    )
  }

  function incluirCarteirinhaFisica() {
    const sim = '1';
    const opcional = '2';
    return (
      federacao?.carteirinha?.carteirinhaFisica == sim ||
      federacao?.carteirinha?.carteirinhaFisica == opcional
    )
  }

  function tipoAquisicaoOpcional() {
    return (incluirCarteirinhaFisica() &&
      federacao?.carteirinha?.opcaoEntrega === '3')
  }

  function tituloCarteirinhaPendente() {
    if (carteirinhaPendente?.id) {
      if (carteirinhaPendente?.pagamento?.status === 3 || carteirinhaPendente?.status === 3) {
        return 'Solicitação Reprovada';
      }
      if (carteirinhaPendente?.status === 0) {
        return 'Soliticação: Pagamento Pendente';
      }
      if (carteirinhaPendente?.status === 1) {
        return 'Sua solicitação de Carteirinha';
      }
    }
    return 'Carteirinha'
  }

  return (
    <div className="body-wrapper blank-loder">
      <Header />
      <div class="section_fullwidth">
        <div class="headline headline_img">
          <div class="headline__inner">
            <div class="headline__title">
              <h1>Carteirinha{tipoCarteirinha == 'dig' ? ' digital' : ''}</h1>
            </div>
            <div class="headline__description">
              <span>Acompanhe aqui sua solicitação de carteirinha {tipoCarteirinha == 'dig' ? ' digital' : ''}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="section_default section-single-class-layout clearfix">
        <main class="section_default">
          <div class="vc_row wpb_row vc_row-fluid vc_custom_1492882415082 vc_column-gap-30">
            <div class="wpb_column vc_column_container vc_col-sm-12">
              <div class="vc_column-inner ">
                <div class="wpb_wrapper">
                  <div class="wpb_text_column wpb_content_element ">

                    <div className='vc_col-sm-12' style={{ display: 'flex', flexDirection: 'column' }}>
                      <div className='wpb_row row'>
                        <h6>Filiado: {filiacao.nomeFiliado} </h6>
                      </div>

                      <div className=' wpb_row row'>

                        <div class="wpb_column vc_column_container vc_col-sm-12">



                          <div class="vc_column-inner">
                            <div class="wpb_wrapper">
                              <div class="wpb_widgetised_column wpb_content_element">
                                <div class="wpb_wrapper">


                                  <div className='vc_col-sm-12' style={{ paddingLeft: '0px' }}>

                                    {!carteirinhaPendente && (
                                      <div className='vc_col-sm-10' style={{ paddingLeft: '0px' }}>
                                        <div className='vc_col-sm-5 form-submit__btn-wrapp btn_defoult'
                                          style={{
                                            background: '#28a745',
                                            cursor: 'pointer',
                                            margin: '15px',
                                            fontSize: '16px',
                                            width: 'max-content',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '45px',
                                            marginLeft: '0px'
                                          }} onClick={() => setNovaCarteirinha(!novaCarteirinha)}>
                                          {`${tipoCarteirinha === 'dig' ? 'Solicitar Carteirinha Digital' : 'Solicitar Nova Carteirinha'}`}
                                        </div>


                                      </div>



                                    )}

                                    {/*<div class={`invisible`}></div>*/}


                                    <div className='vc_col-sm-2' style={{ paddingLeft: '0px' }}>
                                      <div className='vc_col-sm-10' style={{ paddingLeft: '0px' }}>
                                        <div className='vc_col-sm-5 form-submit__btn-wrapp btn_defoult'
                                          style={{
                                            background: '#007bff',
                                            cursor: 'pointer',
                                            margin: '15px',
                                            fontSize: '16px',
                                            width: `${mediaQuery.matches ? '228px' : 'max-content'}`,
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '45px',
                                            marginLeft: '0px'
                                          }} onClick={() => { window.location.href = `/detalheFiliacao?f=${idFederacao}&fl=${idFiliacao}` }}>
                                          <i class="fa fa-arrow-left" aria-hidden="true"></i> Voltar
                                        </div>


                                      </div>
                                    </div>


                                  </div>


                                  {novaCarteirinha && (

                                    <div className='vc_col-sm-12' style={{ border: '1px solid rgba(0, 0, 0, .125)', borderRadius: '5px', padding: '15px' }}>
                                      {/* Tabela Extrato */}
                                      <table className='vc_col-sm-12' style={{ marginTop: 20, width: "100%" }}>
                                        <thead>
                                          <tr >
                                            <th class="schedule-table__day">Extrato</th>
                                          </tr>
                                        </thead>
                                      </table>

                                      <table style={{ width: "100%" }} className="vc_col-sm-12">
                                        <tbody>

                                          <tr>
                                            <td>Carteirinha{tipoCarteirinha === 'dig' ? ' Digital' : ''}</td>
                                            <td>{valorCarteirinha().toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                                          </tr>

                                          {(cobrarTaxaEnvio() && tipoCarteirinha === 'fis') && (
                                            <tr>
                                              <td>Taxa de Envio</td>
                                              <td>{parseFloat(federacao?.carteirinha?.valorTaxaEnvio).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                                            </tr>
                                          )}

                                          <tr>
                                            <td><b>Total a Pagar</b></td>
                                            <td><b>{valorTotal().toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</b></td>
                                          </tr>

                                        </tbody>
                                      </table>
                                      {/* Tabela Extrato - Fim */}

                                      {/* Taxa Entrega Opcional - Início */}

                                      {tipoCarteirinha === 'fis' && (
                                        <>
                                          {tipoAquisicaoOpcional() && (
                                            <div className="vc_col-sm-12" style={{ border: '1px solid rgba(0, 0, 0, .125)', borderRadius: '5px', padding: '5px 14px', width: '100%', marginTop: '15px' }}>
                                              <FormControl component="fieldset">
                                                <h6>Selecione uma opção de recebimento da carteirinha</h6>
                                                <RadioGroup
                                                  aria-label="options"
                                                  name="options"
                                                  value={opcaoEntregaSelecionado}
                                                  onChange={(e) => setOpcaoEntregaSelecionado(e.target.value)}
                                                  style={{ display: 'flex', flexDirection: 'row' }}
                                                >
                                                  <FormControlLabel value="1" control={<Radio />} label="Retirar na Federação" style={{ width: 'max-content' }} />
                                                  <FormControlLabel value="2" control={<Radio />} label="Enviar ao Filiado" />

                                                </RadioGroup>
                                              </FormControl>

                                              {opcaoEntregaSelecionado == '1' && (
                                                <div className='col-md-12' style={{ marginTop: '10px' }}>

                                                  <b>Endereço/Local de entrega da carteirinha: </b>{ReactHtmlParser(federacao?.carteirinha?.enderecoRetiradaCarteirinha)}

                                                </div>
                                              )}

                                              {opcaoEntregaSelecionado == '2' && (


                                                <div style={{
                                                  border: '1px solid rgba(0, 0, 0, .125)',
                                                  borderRadius: '5px',
                                                  padding: '5px',
                                                  width: '100%',
                                                  height: mediaQuery.matches ? '600px' : 'initial',
                                                  marginTop: '15px', marginBottom: '15px'
                                                }} className='vc_col-sm-12' >

                                                  <p class="contact-form-name vc_col-sm-12">
                                                    <span class="wpcf7-form-control-wrap your-name">
                                                      <h6>Endereço de Entrega:</h6>
                                                    </span>
                                                  </p>

                                                  <p class="contact-form-name vc_col-sm-4">
                                                    <span class="wpcf7-form-control-wrap your-name">
                                                      <h6>Endereço</h6>
                                                      <input
                                                        type="text" name="your-name" size="40"
                                                        class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                        aria-required="true" aria-invalid="false"
                                                        onChange={(e) => setEndereco(e.target.value)}
                                                        value={endereco}
                                                      />
                                                    </span>
                                                  </p>

                                                  <p class="contact-form-name vc_col-sm-2">
                                                    <span class="wpcf7-form-control-wrap your-name">
                                                      <h6>N°</h6>
                                                      <input
                                                        type="text" name="your-name" size="40"
                                                        class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                        aria-required="true" aria-invalid="false"
                                                        onChange={(e) => setNumero(e.target.value)}
                                                        value={numero} />
                                                    </span>
                                                  </p>

                                                  <p class="contact-form-name vc_col-sm-3">
                                                    <span class="wpcf7-form-control-wrap your-name">
                                                      <h6>Complemento</h6>
                                                      <input
                                                        type="text" name="your-name" size="40"
                                                        class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                        aria-required="true" aria-invalid="false"
                                                        onChange={(e) => setComplemento(e.target.value)}
                                                        value={complemento} />
                                                    </span>
                                                  </p>

                                                  <p class="contact-form-name vc_col-sm-3">
                                                    <span class="wpcf7-form-control-wrap your-name">
                                                      <h6>Bairro</h6>
                                                      <input
                                                        type="text" name="your-name" size="40"
                                                        class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                        aria-required="true" aria-invalid="false"
                                                        onChange={(e) => setBairro(e.target.value)}
                                                        value={bairro} />
                                                    </span>
                                                  </p>
                                                  <p class="contact-form-name vc_col-sm-3">
                                                    <span class="wpcf7-form-control-wrap your-name">
                                                      <h6>Cidade</h6>
                                                      <input
                                                        type="text" name="your-name" size="40"
                                                        class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                        aria-required="true" aria-invalid="false"
                                                        onChange={(e) => setCidade(e.target.value)}
                                                        value={cidade} />
                                                    </span>
                                                  </p>
                                                  <p class="contact-form-name vc_col-sm-2">
                                                    <span class="wpcf7-form-control-wrap your-name">
                                                      <h6>Estado</h6>
                                                      <select name="select" id="select" className="wpcf7-form-control wpcf7-text wpcf7-validates-as-require" onChange={(e) => setUf(e.target.value)} >
                                                        <option value="">Escolha</option>
                                                        {UFs.map(_uf => (
                                                          <option value={_uf} selected={_uf === uf}>{_uf}</option>
                                                        )
                                                        )}
                                                      </select>

                                                    </span>
                                                  </p>



                                                  <p class="contact-form-name vc_col-sm-2">
                                                    <span class="wpcf7-form-control-wrap your-name">
                                                      <h6>CEP</h6>
                                                      <input
                                                        type="text" name="your-name" size="40"
                                                        class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                        aria-required="true" aria-invalid="false"
                                                        onChange={(e) => setCep(e.target.value)}
                                                        value={cep} />
                                                    </span>
                                                  </p>
                                                </div>
                                              )}


                                            </div>
                                          )}

                                          {(incluirCarteirinhaFisica() &&
                                            federacao?.carteirinha?.opcaoEntrega === '1') && (
                                              <div className="vc_col-sm-12" style={{ border: '1px solid rgba(0, 0, 0, .125)', borderRadius: '5px', padding: '5px 14px', width: '100%', marginTop: '15px' }}>

                                                <div className='col-md-12' style={{ marginLeft: '80px' }}>

                                                  <b>Endereço/Local de entrega da carteirinha: </b>{ReactHtmlParser(federacao?.carteirinha?.enderecoRetiradaCarteirinha)}

                                                </div>
                                              </div>
                                            )}
                                        </>
                                      )}


                                      {/* Taxa Entrega Opcional - Fim */}


                                      <div className='vc_col-md-12'>
                                        <div className='vc_col-md-12' style={{ width: '100%', display: 'flex', alignItems: 'center', padding: '10px', justifyContent: 'center', marginTop: '15px' }}>
                                          <div onClick={() => salvar()}
                                            style={{
                                              background: '#28a745',
                                              cursor: 'pointer',
                                              display: 'flex',
                                              alignItems: 'center', justifyContent: 'center',
                                              height: '40px',
                                              marginRight: '10px',
                                              fontSize: '16px',
                                              minWidth: 'max-content',
                                            }} class={`form-submit__btn-wrapp btn_defoult btn_fill vc_col-md-3`}>
                                            <span style={{ marginRight: '5px' }}>Salvar Pedido </span> <i class="fa fa-floppy-o" aria-hidden="true"></i>
                                          </div>

                                          {exibirBotaoPagamento() && (
                                            <div style={{ background: 'orange', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '40px' }} class={`form-submit__btn-wrapp btn_defoult btn_fill vc_col-md-3`}>
                                              <a href={`/carteirinha/pagamento?fd=${idFederacao}&fl=${idFiliacao}&tp=${tipoCarteirinha}&crt=${carteirinhaPendente?.id}`} style={{ cursor: 'pointer', fontSize: '16px' }} class="wpcf7-form-control wpcf7-pnchr_submit" > Pagamento <i class="fa fa-arrow-right" aria-hidden="true"></i></a>
                                            </div>
                                          )}

                                        </div>

                                      </div>

                                    </div>

                                  )}


                                  {carteirinhaPendente?.id && (

                                    <div role="form" class="row vc_col-sm-12" style={{ border: `2px solid ${corMensagem(carteirinhaPendente)}`, marginTop: '35px', borderRadius: '5px', paddingBottom: '10px' }} >
                                      {/* Tabela Carteirinha Reprovada - Inicio */}
                                      {(true) && (
                                        <>
                                          <div id="ratings-widget-25" class="widget_ratings-widget clearfix vc_col-sm-12" style={{ textAlign: 'center', marginBottom: '10px', marginTop: '35px' }}>
                                            <h3 style={{ color: corMensagem(carteirinhaPendente), lineHeight: 'normal' }}><span style={{ marginRight: '10px' }}>{tituloCarteirinhaPendente()}</span>

                                              {carteirinhaPendente?.status === 3 || carteirinhaPendente?.pagamento?.status === 3 && (
                                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                              )}
                                            </h3>
                                          </div>
                                          <table style={{ width: "100%", marginTop: '0px' }}>
                                          </table>
                                          {mediaQuery.matches ? (
                                            <>
                                              <table>
                                                <tbody>
                                                  <tr>
                                                    <td>Data Solicitação</td>
                                                    <td>{converterData(carteirinhaPendente.dtPedido)}</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Valor</td>
                                                    <td>{carteirinhaPendente?.valorTotal > 0 ? carteirinhaPendente.valorTotal.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : '--'}</td>
                                                  </tr>
                                                  <tr>
                                                    <td>Data Atualizado</td>
                                                    <td>{carteirinhaPendente.dtAtualizado ? converterData(carteirinhaPendente.dtAtualizado) : '--'}</td>
                                                  </tr>
                                                  {/* <tr>
                                                  <td>Observação</td>
                                                  <td>
                                                  <div
                                                      className={`badge-doc-reprovada badge-danger`}
                                                      style={{ cursor: 'pointer', background: corMensagem(carteirinhaPendente) }}
                                                      onClick={() =>
                                                        mensagemObservacaoPendente(carteirinhaPendente)
                                                      } data-toggle="modal" data-target="#modal"
                                                    >
                                                      <span className={`badge-doc-reprovada badge-danger`} style={{ background: corMensagem(carteirinhaPendente) }}><i className='fa fa-commenting'></i></span>
                                                    </div>
                                                  </td>
                                                </tr> */}

                                                </tbody>

                                              </table>
                                              <table style={{ width: "100%" }}>
                                                <tbody>
                                                  <tr>
                                                    <td style={{
                                                      display: 'flex', justifyContent: 'center', padding: '10px 0px'
                                                    }}>
                                                      <div style={{ background: corMensagem(carteirinhaPendente), cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '40px' }} class={`form-submit__btn-wrapp btn_defoult btn_fill vc_col-md-12`} onClick={() =>
                                                        mensagemObservacaoPendente(carteirinhaPendente)
                                                      } data-toggle="modal" data-target="#modal">
                                                        <span style={{ marginRight: '5px' }}>Observação </span><i class="fa fa-commenting" aria-hidden="true"></i>
                                                      </div>
                                                    </td>

                                                  </tr>
                                                </tbody>
                                              </table>
                                              <table style={{ width: "100%" }}>
                                                <tbody>
                                                  <tr>
                                                    <td style={{
                                                      display: 'flex', justifyContent: 'center', padding: '10px 0px'
                                                    }}>
                                                      <div style={{ background: '#2778c4', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '40px' }} class={`form-submit__btn-wrapp btn_defoult btn_fill vc_col-md-12`} onClick={() => {
                                                        handleExibirDetalhesCarteirinhaPendente()
                                                      }}>
                                                        <span style={{ marginRight: '5px' }}>Detalhes </span><i class="fa fa-search" aria-hidden="true"></i>
                                                      </div>
                                                    </td>

                                                  </tr>
                                                </tbody>
                                              </table>
                                            </>
                                          ) : (
                                            <Table style={{ width: "100%" }}>
                                              <Thead style={{ height: '15px' }}>
                                                <Tr style={{ background: '#121212', color: 'white' }}>
                                                  <Th style={{ height: '15px' }} class="" >Data Solicitação </Th>
                                                  <Th style={{ height: '15px' }} class="" >Valor </Th>
                                                  <Th style={{ height: '15px' }} class="">Data Atualizado</Th>

                                                  <Th style={{ height: '15px' }} class="">Observação</Th>
                                                  <Th style={{ height: '15px' }} class=""></Th>
                                                </Tr>
                                              </Thead>
                                              <Tbody>

                                                <Tr>
                                                  <Td>{converterData(carteirinhaPendente.dtPedido)}</Td>
                                                  <Td>{carteirinhaPendente?.valorTotal > 0 ? carteirinhaPendente.valorTotal.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : '--'}</Td>

                                                  <Td>{carteirinhaPendente.dtAtualizado ? converterData(carteirinhaPendente.dtAtualizado) : '--'}</Td>


                                                  <Td>
                                                    <div
                                                      className={`badge-doc-reprovada badge-danger`}
                                                      style={{ cursor: 'pointer', background: corMensagem(carteirinhaPendente) }}
                                                      onClick={() =>
                                                        mensagemObservacaoPendente(carteirinhaPendente)
                                                      } data-toggle="modal" data-target="#modal"
                                                    >
                                                      <span className={`badge-doc-reprovada badge-danger`} style={{ background: corMensagem(carteirinhaPendente) }}><i className='fa fa-commenting'></i></span>
                                                    </div>
                                                  </Td>
                                                  <Td>

                                                    {true && (
                                                      <div style={{ background: '#2778c4', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '40px' }} class={`form-submit__btn-wrapp btn_defoult btn_fill vc_col-md-12`} onClick={() => {
                                                        handleExibirDetalhesCarteirinhaPendente()
                                                      }}>
                                                        <span style={{ marginRight: '5px' }}>Detalhes </span><i class="fa fa-search" aria-hidden="true"></i>
                                                      </div>
                                                    )}

                                                  </Td>

                                                </Tr>



                                              </Tbody>
                                            </Table>
                                          )}


                                          {/* detalhes */}
                                          {carteirinhaPendente?.exibirDetalhes && (

                                            <div className='vc_col-sm-12' style={{ border: '1px solid rgba(0, 0, 0, .125)', borderRadius: '5px', padding: '15px', marginTop: '10px' }}>
                                              {/* Tabela Extrato */}

                                              {carteirinhaPendente?.origemEmissao === 'individual' && (
                                                <>
                                                  <table className='vc_col-sm-12' style={{ marginTop: 20, width: "100%" }}>
                                                    <thead>
                                                      <tr >
                                                        <th class="schedule-table__day">Extrato</th>
                                                      </tr>
                                                    </thead>
                                                  </table>

                                                  <table style={{ width: "100%" }} className="vc_col-sm-12">
                                                    <tbody>

                                                      <tr>
                                                        <td>Carteirinha{tipoCarteirinha === 'dig' ? ' Digital' : ''}</td>
                                                        <td>{(carteirinhaPendente?.valorCarteirinha ? parseFloat(carteirinhaPendente?.valorCarteirinha) : 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                                                      </tr>

                                                      {(cobrarTaxaEnvio() && tipoCarteirinha === 'fis') && (
                                                        <tr>
                                                          <td>Taxa de Envio</td>
                                                          <td>{parseFloat(federacao?.carteirinha?.valorTaxaEnvio).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                                                        </tr>
                                                      )}

                                                      <tr>
                                                        <td><b>Total a Pagar</b></td>
                                                        <td><b>{(carteirinhaPendente?.valorTotal ? parseFloat(carteirinhaPendente?.valorTotal) : 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</b></td>
                                                      </tr>

                                                    </tbody>
                                                  </table>
                                                </>
                                              )}

                                              {/* Tabela Extrato - Fim */}

                                              {/* Taxa Entrega Opcional - Início */}

                                              {tipoCarteirinha === 'fis' && (
                                                <>
                                                  {tipoAquisicaoOpcional() && (
                                                    <div className="vc_col-sm-12" style={{ border: '1px solid rgba(0, 0, 0, .125)', borderRadius: '5px', padding: '5px 14px', width: '100%', marginTop: '15px' }}>
                                                      <FormControl component="fieldset" disabled={carteirinhaPendente}>
                                                        <h6>Selecione uma opção de recebimento da carteirinha</h6>
                                                        <RadioGroup
                                                          aria-label="options"
                                                          name="options"
                                                          value={carteirinhaPendente.opcaoEntregaSelecionado}
                                                          onChange={(e) => { handleSelecaoOpcaoEntrega(e.target.value) }

                                                          }
                                                          style={{ display: 'flex', flexDirection: 'row' }}
                                                        >
                                                          <FormControlLabel value="1" control={<Radio />} label="Retirar na Federação" width='max-content' style={{ width: 'max-content' }} />
                                                          <FormControlLabel value="2" control={<Radio />} label="Enviar ao Filiado" />

                                                        </RadioGroup>
                                                      </FormControl>

                                                      {carteirinhaPendente?.opcaoEntregaSelecionado == '1' && (
                                                        <div className='col-md-12' style={{ marginTop: '10px' }}>

                                                          <b>Endereço/Local de entrega da carteirinha: </b>{ReactHtmlParser(federacao?.carteirinha?.enderecoRetiradaCarteirinha)}

                                                        </div>
                                                      )}

                                                      {carteirinhaPendente?.opcaoEntregaSelecionado == '2' && (


                                                        <div style={{
                                                          border: mediaQuery.matches ? 'none' : '1px solid rgba(0, 0, 0, .125)', borderRadius: '5px', padding: '5px', width: '100%', marginTop: '15px', marginBottom: '15px',
                                                          height: mediaQuery.matches ? '580px' : 'initial'
                                                        }} className='vc_col-sm-12' >

                                                          <p class="contact-form-name vc_col-sm-12">
                                                            <span class="wpcf7-form-control-wrap your-name">
                                                              <h6 style={{ width: 'max-content' }}>Endereço de Entrega:</h6>
                                                            </span>
                                                          </p>

                                                          <p class="contact-form-name vc_col-sm-4" style={{ padding: mediaQuery.matches ? '0px' : 'inherit' }}>
                                                            <span class="wpcf7-form-control-wrap your-name">
                                                              <h6>Endereço</h6>
                                                              <input
                                                                type="text" name="your-name" size="40"
                                                                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                                aria-required="true" aria-invalid="false"
                                                                onChange={(e) => handleEditarEndereco(e.target.value, 'endereco')
                                                                }
                                                                value={carteirinhaPendente?.enderecoEntregaCarteirinha?.endereco}
                                                                disabled={carteirinhaPendente?.status !== 3}
                                                              />
                                                            </span>
                                                          </p>

                                                          <p class="contact-form-name vc_col-sm-2" style={{ padding: mediaQuery.matches ? '0px' : 'inherit' }}>
                                                            <span class="wpcf7-form-control-wrap your-name">
                                                              <h6>N°</h6>
                                                              <input
                                                                type="text" name="your-name" size="40"
                                                                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                                aria-required="true" aria-invalid="false"
                                                                onChange={(e) => handleEditarEndereco(e.target.value, 'numero')
                                                                }
                                                                value={carteirinhaPendente?.enderecoEntregaCarteirinha?.numero}
                                                                disabled={carteirinhaPendente?.status !== 3}
                                                              />
                                                            </span>
                                                          </p>

                                                          <p class="contact-form-name vc_col-sm-3" style={{ padding: mediaQuery.matches ? '0px' : 'inherit' }}>
                                                            <span class="wpcf7-form-control-wrap your-name">
                                                              <h6>Complemento</h6>
                                                              <input
                                                                type="text" name="your-name" size="40"
                                                                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                                aria-required="true" aria-invalid="false"
                                                                onChange={(e) => handleEditarEndereco(e.target.value, 'complemento')}
                                                                value={carteirinhaPendente?.enderecoEntregaCarteirinha?.complemento}
                                                                disabled={carteirinhaPendente?.status !== 3}
                                                              />
                                                            </span>
                                                          </p>

                                                          <p class="contact-form-name vc_col-sm-3" style={{ padding: mediaQuery.matches ? '0px' : 'inherit' }}>
                                                            <span class="wpcf7-form-control-wrap your-name">
                                                              <h6>Bairro</h6>
                                                              <input
                                                                type="text" name="your-name" size="40"
                                                                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                                aria-required="true" aria-invalid="false"
                                                                onChange={(e) => handleEditarEndereco(e.target.value, 'bairro')}
                                                                value={carteirinhaPendente?.enderecoEntregaCarteirinha?.bairro}
                                                                disabled={carteirinhaPendente?.status !== 3}
                                                              />
                                                            </span>
                                                          </p>
                                                          <p class="contact-form-name vc_col-sm-3" style={{ padding: mediaQuery.matches ? '0px' : 'inherit' }}>
                                                            <span class="wpcf7-form-control-wrap your-name">
                                                              <h6>Cidade</h6>
                                                              <input
                                                                type="text" name="your-name" size="40"
                                                                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                                aria-required="true" aria-invalid="false"
                                                                onChange={(e) => handleEditarEndereco(e.target.value, 'cidade')}
                                                                value={carteirinhaPendente?.enderecoEntregaCarteirinha?.cidade}
                                                                disabled={carteirinhaPendente?.status !== 3}
                                                              />
                                                            </span>
                                                          </p>
                                                          <p class="contact-form-name vc_col-sm-2" style={{ padding: mediaQuery.matches ? '0px' : 'inherit' }}>
                                                            <span class="wpcf7-form-control-wrap your-name">
                                                              <h6>Estado</h6>
                                                              <select name="select" id="select" className="wpcf7-form-control wpcf7-text wpcf7-validates-as-require" onChange={(e) => handleEditarEndereco(e.target.value, 'uf')} value={carteirinhaPendente?.enderecoEntregaCarteirinha?.uf} disabled={carteirinhaPendente?.status !== 3} >
                                                                <option value="">Escolha</option>
                                                                {UFs.map(_uf => (
                                                                  <option value={_uf} selected={_uf === uf}>{_uf}</option>
                                                                )
                                                                )}
                                                              </select>

                                                            </span>
                                                          </p>



                                                          <p class="contact-form-name vc_col-sm-2" style={{ padding: mediaQuery.matches ? '0px' : 'inherit' }}>
                                                            <span class="wpcf7-form-control-wrap your-name">
                                                              <h6>CEP</h6>
                                                              <input
                                                                type="text" name="your-name" size="40"
                                                                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                                                aria-required="true" aria-invalid="false"
                                                                onChange={(e) => handleEditarEndereco(e.target.value, 'cep')}
                                                                value={carteirinhaPendente?.enderecoEntregaCarteirinha?.cep} disabled={carteirinhaPendente?.status !== 3} />
                                                            </span>
                                                          </p>
                                                        </div>
                                                      )}


                                                    </div>
                                                  )}

                                                  {(incluirCarteirinhaFisica() &&
                                                    federacao?.carteirinha?.opcaoEntrega === '1') && (
                                                      <div className="vc_col-sm-12" style={{ border: '1px solid rgba(0, 0, 0, .125)', borderRadius: '5px', padding: '5px 14px', width: '100%', marginTop: '15px' }}>

                                                        <div className='col-md-12' style={{ marginLeft: '80px' }}>

                                                          <b>Endereço/Local de entrega da carteirinha: </b>{ReactHtmlParser(federacao?.carteirinha?.enderecoRetiradaCarteirinha)}

                                                        </div>
                                                      </div>
                                                    )}
                                                </>
                                              )}


                                              {/* Taxa Entrega Opcional - Fim */}


                                              <div className='vc_col-md-12' style={{ padding: '0px' }}>
                                                <div className='vc_col-md-12' style={{
                                                  width: '100%',
                                                  display: mediaQuery.matches ? 'block' : 'flex',
                                                  alignItems: 'center',
                                                  padding: '0px', justifyContent: 'center', marginTop: '15px'
                                                }}>

                                                  {exibirBotaoAlterarDados() && (
                                                    <div onClick={() => alterarDados(carteirinhaPendente)} style={{
                                                      background: '#28a745', cursor: 'pointer',
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      height: '40px',
                                                      marginRight: '10px',
                                                      fontSize: '16px',
                                                      marginBottom: '10px'
                                                    }} class={`form-submit__btn-wrapp btn_defoult btn_fill vc_col-md-3`}>
                                                      <span style={{ marginRight: '5px' }}>Alterar Dados </span> <i class="fa fa-refresh" aria-hidden="true"></i>
                                                    </div>
                                                  )}


                                                  {exibirBotaoPagamento() && (
                                                    <div style={{ background: 'orange', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '40px', marginBottom: '10px' }} class={`form-submit__btn-wrapp btn_defoult btn_fill vc_col-md-3`}>
                                                      <a href={`/carteirinha/pagamento?fd=${idFederacao}&fl=${idFiliacao}&tp=${tipoCarteirinha}&crt=${carteirinhaPendente?.id}`} style={{ cursor: 'pointer', fontSize: '16px', width: 'max-content' }} class="wpcf7-form-control wpcf7-pnchr_submit" > Pagamento <i class="fa fa-arrow-right" aria-hidden="true"></i></a>
                                                    </div>
                                                  )}

                                                </div>

                                              </div>



                                            </div>

                                          )}
                                        </>
                                      )}
                                      {/* Tabela Carteirinha Reprovada - Fim */}
                                    </div>

                                  )}







                                  <div role="form" class="row vc_col-sm-12" >







                                  </div>

                                  {carteirinhas.filter(crt => crt.status === 5).length > 0 && (
                                    <div role="form" class="row vc_col-sm-12" >



                                      {/* Tabela Histórico - Inicio */}
                                      {(tipoCarteirinha !== 'dig') && (
                                        <>
                                          <div id="ratings-widget-25" class="widget_ratings-widget clearfix vc_col-sm-12" style={{ textAlign: 'center', marginBottom: '10px', marginTop: '35px' }}>
                                            <h3>Solicitações Concluídas</h3>
                                          </div>
                                          <table style={{ width: "100%", marginTop: '0px' }}>
                                          </table>
                                          <Table style={{ width: "100%" }}>
                                            <Thead style={{ height: '15px' }}>
                                              <Tr style={{ background: '#121212', color: 'white' }}>
                                                <Th style={{ height: '15px' }} class="" >Data Solicitação </Th>
                                                <Th style={{ height: '15px' }} class="">Data Atualizado</Th>
                                                <Th style={{ height: '15px' }} class="">{tipoCarteirinha === 'dig' ? 'Data Habilitada' : 'Data Entregue'}</Th>
                                                {(!tipoCarteirinha === 'dig') && (
                                                  <Th style={{ height: '15px' }} class="">Endereço</Th>
                                                )}
                                                <Th style={{ height: '15px' }} class="">Situação</Th>
                                                <Th style={{ height: '15px' }} class="">Observação</Th>
                                              </Tr>
                                            </Thead>
                                            <Tbody>
                                              {carteirinhas.filter(crt => crt.status === 5).sort((a, b) => b.dtPedido - a.dtPedido).map(carteirinha => (
                                                <Tr>
                                                  <Td>{converterData(carteirinha.dtPedido)}</Td>
                                                  <Td>{carteirinha.dtAtualizado ? converterData(carteirinha.dtAtualizado) : '--'}</Td>
                                                  <Td>{carteirinha.dtEntregue ? converterData(carteirinha.dtEntregue) : '--'}</Td>

                                                  {(!tipoCarteirinha === 'dig') && (
                                                    <Td>
                                                      <div
                                                        className={`badge-danger badge-doc-reprovada`}
                                                        onClick={() =>
                                                          mensagemEndereco(carteirinha)
                                                        } style={{ background: 'rgb(0, 123, 255)', cursor: 'pointer' }} >
                                                        <span className={`badge-danger badge-doc-reprovada`} style={{ background: 'rgb(0, 123, 255)' }}><i className='fa fa-tag'></i></span>
                                                      </div>
                                                    </Td>

                                                  )}
                                                  <Td>

                                                    <span style={{ fontWeight: 'bold', color: corMensagem(carteirinha) }}>{
                                                      mensagemStatus(carteirinha.status)}</span>

                                                  </Td>
                                                  <Td>
                                                    <div
                                                      className={`badge-doc-reprovada badge-danger`}
                                                      style={{ cursor: 'pointer', background: corMensagem(carteirinha) }}
                                                      onClick={() =>
                                                        mensagemObservacao(carteirinha.status, carteirinha.observacao)
                                                      } data-toggle="modal" data-target="#modal"
                                                    >
                                                      <span className={`badge-doc-reprovada badge-danger`} style={{ background: corMensagem(carteirinha) }}><i className='fa fa-commenting'></i></span>
                                                    </div>
                                                  </Td>


                                                </Tr>
                                              ))}

                                            </Tbody>
                                          </Table>
                                        </>
                                      )}



                                    </div>

                                  )}



                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </main>
      </div>
      <Footer />
    </div>
  );
}
